module.exports = __webpack_public_path__ + "yubikeyDemo.f10c9db1d9eb441f0bdaffce5bb672a1.png";